import UrlParse from 'url-parse'

/**
 * Grab Hostname from URL
 *
 * Step 1: Use url-parse to split the URL parts
 * Step 2: Return the hostname
 */
export default function HostNameParser (callback_url) {
    try {
        if (callback_url.indexOf('http') === -1) callback_url = 'http://'+callback_url;
        const parts = new UrlParse(callback_url);
        return parts.hostname;
    } catch (err) {
        return "";
    }
}



// WEBPACK FOOTER //
// ./src/utils/HostNameParser.js